import { render, staticRenderFns } from "./ModalErrorUser.vue?vue&type=template&id=084b1abd&scoped=true&"
import script from "./ModalErrorUser.vue?vue&type=script&lang=js&"
export * from "./ModalErrorUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalErrorUser.vue?vue&type=style&index=0&id=084b1abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b1abd",
  null
  
)

export default component.exports